import { Badge } from '@/components/ui/badge';
import { cn } from '@/lib/utils';
import { Tables } from '@/types/database.types';
import { formatAPIKey } from '@/utils';
import {
  fCurrencyExtended,
  fCurrencyUSD,
  fCurrencyUSDExtended,
} from '@/utils/formatNumber';
import { fFullDateTime } from '@/utils/formatTime';
import { ColumnDef } from '@tanstack/react-table';
import dayjs from 'dayjs';

export const columns: ColumnDef<Tables<'balance_history'>>[] = [
  // {
  //   accessorKey: 'api_key',
  //   header: 'API key',
  //   cell: ({ row }) => formatAPIKey(row.getValue('api_key')),
  // },
  {
    accessorKey: 'timestampz',
    header: 'Datetime',
    cell: ({ row }) => {
      return fFullDateTime(row.getValue('timestampz'));
    },
    size: 100,
  },
  {
    accessorKey: 'balance_action',
    header: 'Action',
    cell: ({ row }) => {
      return (
        <Badge variant="secondary">{row.getValue('balance_action')}</Badge>
      );
    },
  },
  {
    accessorKey: 'amount',
    header: () => <div className="text-right">Amount</div>,
    cell: ({ row }) => {
      return (
        <div
          className={cn(
            'text-right font-medium',
            (row.getValue('amount') as number) > 0
              ? 'text-green-600'
              : 'text-red-600'
          )}
        >
          {fCurrencyUSDExtended(row.getValue('amount'))}
        </div>
      );
    },
  },
];
